module.exports = __webpack_public_path__ + "static/media/bookmark.f212cf74.svg";